import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TThunkDispatch } from '../../types/redux';
import { IFiltersUpdatedEventDetail } from '../../types/desktopFilters';
import { setJsonQuery } from '../../actions/filters';
import { ISearchMeta } from '../../types/searchMeta';
import { useApplicationContext } from '../../utils/applicationContext';

/**
 * Подписывается на событие из микрофронта на применение фильтров
 * @returns {object} searchMeta - метаданные поиска из события фильтров
 */
export const useFiltersUpdatedEvent = () => {
  const { microfrontendsAPI } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const [searchMeta, setSearchMeta] = useState<ISearchMeta>();

  useEffect(() => {
    const onFiltersUpdated = ({ detail }: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(setJsonQuery(detail.jsonQuery));

      setSearchMeta(detail.searchMeta);

      if (microfrontendsAPI) {
        microfrontendsAPI.getSearchStringMicrofrontendAPI().setFilterJsonQuery(detail.jsonQuery);
      }
    };

    addEventListener('filters:updated', onFiltersUpdated);

    return () => {
      removeEventListener('filters:updated', onFiltersUpdated);
    };
  }, [dispatch]);

  return { searchMeta };
};
